export default __webpack_public_path__ + "static/media/banner.dba36f61.png";